import { createFileRoute } from '@tanstack/react-router';
import Contact from '~/components/Contact';
import { PageSection } from '~/routes/__root';

export const Route = createFileRoute('/contact')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex min-h-screen flex-col">

      <PageSection
        padding="large"
        className="my-auto w-full flex-grow bg-blackpng bg-cover bg-no-repeat xl:w-full"
      >
        <Contact />
      </PageSection>
    </div>
  );
}
